
namespace Matrix.Workflow {

    @Serenity.Decorators.registerClass()
    export class QueueTypeGrid extends SiteEntityGrid<QueueTypeRow, any> {
        protected getColumnsKey() { return 'Workflow.QueueType'; }
        protected getDialogType() { return QueueTypeDialog; }
        protected getIdProperty() { return QueueTypeRow.idProperty; }
        protected getInsertPermission() { return QueueTypeRow.insertPermission; }
        protected getLocalTextPrefix() { return QueueTypeRow.localTextPrefix; }
        protected getService() { return QueueTypeService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}